
import EmojiPickerOverlay from 'components/emoji_picker/emoji_picker_overlay';
import {KEYBOARD_SHORTCUTS} from 'components/keyboard_shortcuts/keyboard_shortcuts_sequence';

import {ActionButton} from 'packages/editor/src/components/action-button';
import {ShortcutTooltip} from 'packages/editor/src/components/shortcut-tooltip';
import {type useEditor} from '../hooks/useEditor';
import {EmoticonOutlineIcon} from '@time-webkit/all/icons/emoticon-outline';

type EmojiPickerProps = {
    editor: ReturnType<typeof useEditor>;
}

export function EmojiPicker({editor}: EmojiPickerProps) {
    return (
        <>
            <EmojiPickerOverlay
                show={editor.state.showEmojiPicker}
                target={() => editor.refs.emojiPickerRef.current}
                onHide={editor.handlers.handleEmojiClose}
                onEmojiClick={editor.handlers.handleEmojiClick}
                topOffset={-7}
            />
            <ShortcutTooltip descriptor={KEYBOARD_SHORTCUTS.addEmoji}>
                <ActionButton
                    aria-label='Emoji picker button'
                    ref={editor.refs.emojiPickerRef}
                    onPress={editor.actions.toggleEmojiPicker}
                    icon={<EmoticonOutlineIcon />}
                />
            </ShortcutTooltip>
        </>
    );
}
